{
  "it": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Modifica logo (richiesto PNG)",
        "changeThemeColor": "Scegli un nuovo colore del tema"
      },
      "labels": {
        "customerThemeColor": "Colore del tema cliente",
        "customerThemeColorExlainer": "Questo colore verrà utilizzato per il portale cliente. Impersonifichi un cliente per vederlo in azione.",
        "logo": "Logo"
      },
      "picture_logo_format": {
        "round": "Logo rotondo",
        "square": "Logo quadrato"
      }
    }
  }
}
